// List of added events:
//
// 'object:moving_start'
// 'object:moving_end'
// 'object:rotating_start'
// 'object:rotating_end'
// 'object:scaling_start'
// 'object:scaling_end'
// 'viewport:pan'
// 'viewport:zoom'

export default class CustomListeners {
    store;
    canvas;

    constructor(store) {
        this.store = store;
        this.canvas = this.store.canvas;
        this.onStartMoving = this.onStartMoving.bind(this);
        this.onEndMoving = this.onEndMoving.bind(this);
        this.onStartRotating = this.onStartRotating.bind(this);
        this.onEndRotating = this.onEndRotating.bind(this);
        this.onStartScaling = this.onStartScaling.bind(this);
        this.onEndScaling = this.onEndScaling.bind(this);

        this.store.canvas.on({
            'object:moving': this.onStartMoving,
            'object:rotating': this.onStartRotating,
            'object:scaling': this.onStartScaling,
        });

        this.store.canvas.on('object:modified', (event) => {
            if (this.moving) {
                this.onEndMoving(event);
            }
            if (this.rotating) {
                this.onEndRotating(event);
            }
            if (this.scaling) {
                this.onEndScaling(event);
            }
        });
    }

    moving = false;
    rotating = false;
    scaling = false;

    onStartMoving(event) {
        if (this.moving) return;
        this.moving = true;
        this.canvas.fire('object:moving_start', event);
    }

    onEndMoving(event) {
        if (!this.moving) return;
        this.moving = false;
        this.canvas.fire('object:moving_end', event);
    }

    onStartRotating(event) {
        if (this.rotating) return;
        this.rotating = true;
        this.canvas.fire('object:rotating_start', event);
    }

    onEndRotating(event) {
        if (!this.rotating) return;
        this.rotating = false;
        this.canvas.fire('object:rotating_end', event);
    }

    onStartScaling(event) {
        if (this.scaling) return;
        this.scaling = true;
        this.canvas.fire('object:scaling_start', event);
    }

    onEndScaling(event) {
        if (!this.scaling) return;
        this.scaling = false;
        this.canvas.fire('object:scaling_end', event);
    }
}
